// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__zzKsp","disabled":"FileBtn_disabled__2uIfU","warn":"FileBtn_warn__lMf9q","fade":"FileBtn_fade__34HQl"};